angular.module('jv.candidate.details.workflow.scheduler.messager.controller', ['jv.calendarFactory', 'ngAnimate'])
.directive('slideToggle', function() {
    return {
        restrict: 'A',
        scope:{},
        link: function(scope, element, attr) {
            element.bind('click', function() {
                var $slideBox = angular.element(attr.slideToggle);
                var slideDuration = parseInt(attr.slideToggleDuration) || 500;
                $slideBox.stop().slideToggle(slideDuration);
            });
        }
    };
})
.controller('jvCandidateDetailsWorkflowSchedulerMessagerController', ['$scope', 'candidates', '$rootScope', '$routeParams', '$localStorage', '$window', '$location', '$filter', 'jvCalendarFactory', 'jvInterviewService', '$log',
    function($scope, candidates, $rootScope, $routeParams, $localStorage, $window, $location, $filter, jvCalendarFactory, jvInterviewService, $log){

    var TEMPLATE_ORDER = [
        'requestAvailabilityTemplate',
        'scheduleTemplate',
        'inviteTemplate',
        'forwardSchedule'
    ];

    $scope.appDetails = $localStorage.appDetails;
    $scope.flags.loading = false;
    $scope.messager = {};
    $scope.messager.loading = [];
    $scope.messager.templates = {};
    $scope.messager.includeConferenceLink = jvInterviewService.getIncludeConferenceLink();
    $scope.messager.videoConferenceEnabled = jvInterviewService.getVideoConferenceEnabled();
    $scope.phoneList = {
        fromPhoneData: {
            label: i18n['FROM'],
            required: true,
            errorText: i18n['JV_SENDMESSAGE_CONTROLLER_THIS_IS_A_REQUIRED_FIELD'],
            data: {
                type: 'dropDown',
                key: 'sendMsgFrom',
                name: 'fromList',
                optionsValues: []
            }
        }
    };

    $scope.goBackToScheduler = function(){
          $location.path('/scheduler/'+$routeParams.applicationId+'/'+$routeParams.stateId);
    };

    $scope.$on('$routeChangeStart', function () {
        var pathSegmentArr = $location.$$path.split('/').reverse();
        if(pathSegmentArr[2] !== 'scheduler'){
            jvInterviewService.clearRequestAvailabilityRestoreState();
        }
    });

    var addLoading = function(loader){
        $scope.messager.loading.push(loader);
        $scope.flags.loading = true;
    };

    var removeLoading = function(loader){
        $scope.messager.loading.splice($scope.messager.loading.indexOf(loader), 1);
        if($scope.messager.loading.length === 0){
            $scope.flags.loading = false;
        }
    };

    var getInterviewerInfo = function(){
        var messageToList = [];
        var interviewers = [];

        interviewers = jvInterviewService.getInterviewers();
        for(var interviewer in interviewers){
            messageToList.push(interviewers[interviewer].fullName);
        }
        $scope.messager.messageToList = messageToList.join(', ') || '-';

        return interviewers;
    };

    var getTemplateInfo = function(){
        var candidate = $scope.appDetails.application.candidate.firstName + ' ' + $scope.appDetails.application.candidate.lastName;
        var agencyCandidate = i18n['COMMON_CANDIDATE'] + ' (' + candidate + ')';
        var interviewers = $scope.messager.messageToList;

        addLoading('TemplateInfo');
        addLoading('CandidateFiles');
        candidates.getRequestAvailabilityTemplate(
            $scope.appDetails.application.job.EId,
            $routeParams.stateId,
            {
                autoSchedule: $scope.messager.scheduledDetails.auto,
                appEIds: $scope.appDetails.application.EId,
                messageType: $scope.messager.scheduledDetails.enableSMSDelivery ? 'SMS' : 'EMAIL'
            },
            function(templateResponse){
                for (var template in templateResponse.templates){
                    templateResponse.templates[template].showAvailability = (template === 'requestAvailabilityTemplate') ? true : false;
                    for (var attachment in templateResponse.templates[template].attachments){
                        templateResponse.templates[template].attachments[attachment].include = true;
                    }
                    if(template === 'requestAvailabilityTemplate' || template === 'inviteTemplate') {
                        if (templateResponse.agencyCandidate) {
                            templateResponse.templates[template].to = i18n['COMMON_AGENCY'] + ' (' + templateResponse.agency.fullName + ')';
                            templateResponse.templates[template].toAgencyCandidate = agencyCandidate;
                            templateResponse.templates[template].hasEmail = $scope.appDetails.application.candidate.email ? true : false;
                            templateResponse.templates[template].includeCandidate = templateResponse.templates[template].hasEmail;
                        } else {
                            templateResponse.templates[template].to = candidate;
                        }
                        if(template === 'inviteTemplate') {
                            templateResponse.templates[template].autoSendEnabled = true;
                            if (typeof $localStorage.autoSendEnabled !== 'undefined') {
                                templateResponse.templates[template].autoSendEnabled = $localStorage.autoSendEnabled;
                            }
                        }
                    } else if(template === 'scheduleTemplate') {
                        templateResponse.templates[template].to = interviewers;
                        templateResponse.templates[template].customMeetingRoomSubject = false;
                        templateResponse.templates[template].meetingRoomSubject = i18n['I18N_MEETING_ROOM_INVITES_PLACEHOLDER'];
                    } else {
                        templateResponse.templates[template].to = '-';
                    }
                }

                Object.assign($scope.messager, templateResponse);
                if($scope.messager.scheduledDetails.auto){
                    Object.assign($scope.messager.templates, {
                        forwardSchedule: {
                            showAvailability: true
                        }
                    });
                }

                candidates.getCandFiles(
                    $scope.appDetails.application.EId,
                    function(candidateErr){
                        $log.error(candidateErr);
                        removeLoading('CandidateFiles');
                    },
                    function(candidateFilesResponse){
                        $scope.messager.resources = angular.copy(candidateFilesResponse.candidateFiles);
                        $scope.messager.resumeExists = false;
                        for(var resource in $scope.messager.resources){
                            if($scope.messager.resources[resource].fileKind === 'Resume'){
                                $scope.messager.resumeExists = true;
                            } else if($scope.messager.resources[resource].fileKind === 'CoverLetter') {
                                $scope.messager.coverLetterExists = true;
                            }
                        }
                        $scope.messager.includeResume = ($scope.messager.attachResume && $scope.messager.resumeExists) ? true : false;
                        $scope.messager.includeCoverLetter = ($scope.messager.attachCoverLetter && $scope.messager.coverLetterExists) ? true : false;
                        removeLoading('CandidateFiles');
                    }
                );
                $scope.messager.templateOrder = TEMPLATE_ORDER;
                removeLoading('TemplateInfo');
            }, function(templateErr){
                $log.error(templateErr);
                removeLoading('TemplateInfo');
            }
        );
    };

    $scope.redirectToWorkflowTab = function() {
        // $scope.scheduler.showDialog = false;
        var url = $window.jvUrls.jhire;
        url += '/modules/candidates/search.html?{0}#/{1}'.format($.param({ mode: 'paginate'}),'workflow/{0}/{1}'.format($routeParams.applicationId, $routeParams.stateId));
        $window.location.href = url;
        // $scope.$parent.closeMiniHeader();
    };

    var getPhoneNoList = function() {
        candidates.getPhoneNoList({
            data: {}
        }, function(resp) {
            if (resp && resp.phoneList && resp.phoneList.content) {
                var phoneListContent = resp.phoneList.content;
                var fromObj = angular.copy($scope.phoneList.fromPhoneData);
                fromObj.data.optionsValues = [];
                for (var phone of phoneListContent) {
                    const phoneData = {
                        label: phone.channelKey,
                        checked: true,
                        displayName: phone.owner.displayName + ' ' + phone.phoneForDisplay,
                        value: phone.channelKey,
                        canvasOwnerId: phone.owner.ownerRefKey,
                        canvasChannelKey: phone.channelKey
                    };
                    fromObj.data.optionsValues.push(phoneData);
                }
                $scope.phoneList.fromPhoneData.data.optionsValues = fromObj.data.optionsValues;
                $scope.phoneList.fromPhone = fromObj.data.optionsValues[0];
            }
        });
    };

    var init = function(){
        var interviewers = getInterviewerInfo();
        $scope.messager.scheduledDetails = angular.copy(jvInterviewService.getSchedulerSlots());
        $scope.messager.scheduledDetails.interviewers = interviewers;
        getTemplateInfo();
        if ($scope.messager.scheduledDetails.enableSMSDelivery) {
            getPhoneNoList();
        }
    };

    if(!$rootScope.miniHeader || !$rootScope.miniHeader.show){
        $rootScope.miniHeader = {
            show: true,
            back: 'workflow/'+$routeParams.applicationId
        };
    }

    $scope.closeMiniHeader = function() {
        $scope.redirectToWorkflowTab();
    };

    $scope.autoSendChecked = function(autoSendEnabled) {
        $localStorage.autoSendEnabled = autoSendEnabled;
    };

    /**
     * @method createAttachmentList
     * @description Creates the atachmentList for the uploads and attachments (Admin enabled) and assigns it to payload
     * @param {Object} template template from which the attachment list needs to be created
     * @returns {Object} list returns the attachment data
     */
    var createAttachmentList = function(template) {
        var list = [];
        angular.forEach(template.uploads, function(value, key){
            list.push(key);
        });
        angular.forEach(template.attachments, function(value){
            if (value.include) {
                list.push(value.eid);
            }
        });
        return list;
    };

    /**
     * @method createBccList
     * @description Creates the bccList for email template
     * @param {Object} bcc list of Users
     * @returns {Object} bccList returns list of EIds
     */
    var createBccList = function(bcc) {
        var bccList = [];
        angular.forEach(bcc, function(value){
            bccList.push(value.EId);
        });
        return bccList;
    };

    /**
     * @method createPayload
     * @description Creates the payload data to be passed to the request availability service
     * @returns {Object} data returns the payload data
     */
    var createPayload = function() {
        var messager = $scope.messager;
        var templates = messager.templates;
        var data = {
            'templates': {},
            'numberOfSlots': messager.scheduledDetails.totalSlots,
            'totalDuration': messager.scheduledDetails.totalDuration,
            'requestedScheduleSlots': [],
            'applications': [$routeParams.applicationId],
            'interviewerBlock': messager.scheduledDetails.interviewerBlock,
            'meetingLocations': [],
            'timeZoneId': angular.isDefined(messager.scheduledDetails.timezone) ? messager.scheduledDetails.timezone.id : '',
            'attachResume': messager.attachResume,
            'attachCoverLetter': messager.attachCoverLetter,
            'autoSchedule': messager.scheduledDetails.auto,
            'useVC': messager.includeConferenceLink,
            'deliveryMethod': $scope.messager.scheduledDetails.enableSMSDelivery ? 'SMS' : 'EMAIL',
            'canvasChannelKey': $scope.phoneList && $scope.phoneList.fromPhone ? $scope.phoneList.fromPhone.canvasChannelKey : '',
            'canvasOwnerId': $scope.phoneList && $scope.phoneList.fromPhone ? $scope.phoneList.fromPhone.canvasOwnerId : ''
          };
        angular.forEach(messager.scheduledDetails.slots, function(value){
            angular.forEach(value.times, function(val){
                var fromDate = moment.tz(val.start._i, $scope.messager.scheduledDetails.timezone.openSysId).format('MMMM DD, YYYY HH:mm:ss');
                var toDate = moment.tz(val.end._i, $scope.messager.scheduledDetails.timezone.openSysId).format('MMMM DD, YYYY HH:mm:ss');
                data.requestedScheduleSlots.push({'fromDate': fromDate, 'toDate': toDate});
            });
        });

        if (angular.isDefined(templates.inviteTemplate) && templates.inviteTemplate.autoSendEnabled) {
            // Interview Invitation To Candidate
            data.templates.inviteTemplate = {
                'bccList': createBccList(templates.inviteTemplate.bcc),
                'content': templates.inviteTemplate.content,
                'subject': templates.inviteTemplate.subject,
                'forms': templates.inviteTemplate.forms,
                'attachmentList': []
            };
            if ($scope.messager.agencyCandidate) {
                data.templates.inviteTemplate.notifyToAgencyOnly = !(templates.inviteTemplate.hasEmail && templates.inviteTemplate.includeCandidate);
            }
            data.templates.inviteTemplate.attachmentList = createAttachmentList(templates.inviteTemplate);
        }

        if (angular.isDefined(templates.scheduleTemplate)) {
            // Interview Invitation(s) To Interviewer(s)
            data.templates.scheduleTemplate = {
                'content': templates.scheduleTemplate.content,
                'subject': templates.scheduleTemplate.subject,
                'attachmentList': [],
                'includeResume': $scope.messager.includeResume,
                'includeCoverLetter': $scope.messager.includeCoverLetter
            };

            if (templates.scheduleTemplate.customMeetingRoomSubject) {
                data.templates.meetingRoomTemplate = {
                    'subject': templates.scheduleTemplate.meetingRoomSubject
                };
            }

            data.templates.scheduleTemplate.attachmentList = createAttachmentList(templates.scheduleTemplate);

            if(angular.isDefined(templates.forwardSchedule)
                && angular.isDefined(templates.forwardSchedule.to)
                && templates.forwardSchedule.to.length > 0){
                var addedFwdRecipents = [];

                for(var i=0; i<templates.forwardSchedule.to.length; i++) {
                    addedFwdRecipents.push({
                        eid: templates.forwardSchedule.to[i].EId
                    });
                }

                data.templates.scheduleTemplate.addedFwdRecipents = addedFwdRecipents;
                if(templates.forwardSchedule.calendarInvite){
                    data.templates.scheduleTemplate.sendForwardInvite = templates.forwardSchedule.calendarInvite;
                }
            }
        }

        if (angular.isDefined(templates.requestAvailabilityTemplate)){
            // Availability Request To Candidate
            data.templates.requestAvailabilityTemplate = {
                'content': templates.requestAvailabilityTemplate.content,
                'subject': templates.requestAvailabilityTemplate.subject,
                'attachmentList': []
            };
            if ($scope.messager.agencyCandidate) {
                data.templates.requestAvailabilityTemplate.notifyToAgencyOnly = !(templates.requestAvailabilityTemplate.hasEmail && templates.requestAvailabilityTemplate.includeCandidate);
            }
            data.templates.requestAvailabilityTemplate.attachmentList = createAttachmentList(templates.requestAvailabilityTemplate);
        }
        angular.forEach(messager.scheduledDetails.meetingRooms, function(value){
            data.meetingLocations.push(value.EId);
        });
        return data;
    };

    /**
     * @method validateEmails
     * @description Validates the email templates for empty subject and body content
     * @param {object} template The email template object which needs to be validated.
     * @returns {boolean} true or false for valid/invalid template
     */
    var validateEmails= function(template){
        return !template.subject || !template.content;
    };

    /**
     * @method sendRequestDisabled
     * @description Validates the email templates - iterates though all the templates
     * @returns {boolean} true or false for valid/invalid template
     */
    $scope.sendRequestDisabled = function() {
        var isTemplateValid = false;
        angular.forEach($scope.messager.templates, function(value, key){
            if($scope.messager.templates.hasOwnProperty(key) && key !== 'forwardSchedule' && !isTemplateValid){
                isTemplateValid = validateEmails(value);
            }
        });
        return isTemplateValid ||
            typeof($scope.messager.scheduledDetails.totalSlots) === 'undefined' ||
            typeof($scope.messager.scheduledDetails.totalDuration) === 'undefined' ||
            typeof($scope.messager.scheduledDetails.slots) === 'undefined' ||
            Object.keys($scope.messager.scheduledDetails.slots).length < 1 ||
            $scope.messager.scheduledDetails.enableSMSDelivery && !$scope.phoneList.fromPhone;
    };

    /**
     * @method requestAvailability
     * @description Creates the payload data and calls the service request for candidate availability
     * @returns Handles the success or failure of the service request.
     */
    $scope.requestAvailability = function(){
        addLoading('sendRequestAvailibility');
        var payload = createPayload();
        candidates.requestCandidateAvailability($routeParams.stateId, payload, function() {
            removeLoading('sendRequestAvailibility');
            // jvHireUrlService.loadCandidateDetailsTab('workflow', $routeParams.applicationId);
            $scope.redirectToWorkflowTab();
        }, function(err) {
            $log.error(err);
            removeLoading('sendRequestAvailibility');
        });
    };
    init();
}]);
